import React, { useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import InsurancesTable from '../../../Insurance/InsurancesTable';

import LenderService from '../../../../../services/LenderService';
import ReportService from '../../../../../services/ReportService';
import downloadDocument from '../../../../../helpers/downloadDocument';
import { useUiStore } from '../../../../../store';
import { useUiContext } from '../../../../../context/UiContext';
import usePagination from '../../../../../hooks/usePagination';

export default function Insurances({ lenderId, isLender }) {
  const [isDownloadButtonDisabled, setIsDownloadButtonDisabled] =
    useState(false);

  const { showToast } = useUiContext();

  const { data: insurances, isFetching } = useQuery({
    queryKey: ['lenderInsurances', lenderId],
    queryFn: () => LenderService.getLenderInsurances(lenderId),
    enabled: !!lenderId && !isLender,
  });

  const {
    currentPage,
    switchToPage,
    pageTotal,
    isFetching: areInsurancesFetching,
    data,
  } = usePagination({
    queryKey: ['lenderInsurances', lenderId],
    queryFn: LenderService.getLenderInsurancesPaginated,
    queryFnArgs: { lenderId },
    enabled: !!lenderId && isLender,
  });

  const createInsuranceLink = (row) => {
    return `/loans/${row.loan_id}/insurances/${row.id}?tab=Insurance`;
  };

  const setIsFetching = useUiStore((state) => state.setIsFetching);

  const downloadReport = async () => {
    try {
      setIsFetching(true);
      setIsDownloadButtonDisabled(true);
      const doc = await ReportService.getLenderInsurancesReport(lenderId);
      await downloadDocument(doc.id, doc.name);
    } catch (error) {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    } finally {
      setIsFetching(false);
      setIsDownloadButtonDisabled(false);
    }
  };

  return (
    <InsurancesTable
      headerRight={
        <div className="flex gap-5 md:gap-10 md:flex-row flex-col items-center">
          <button
            disabled={isDownloadButtonDisabled}
            type="button"
            className="btn dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-indigo-500"
            onClick={downloadReport}
          >
            Report
          </button>
        </div>
      }
      isFetching={isLender ? areInsurancesFetching : isFetching}
      insurances={isLender ? data?.items : insurances}
      createInsuranceLink={createInsuranceLink}
      isLender={isLender}
      pageTotal={pageTotal}
      currentPage={currentPage}
      switchToPage={switchToPage}
    />
  );
}
